export function ImagesEn() {
    return require.context('./img/en', false, /\.(png|jpe?g|gif|svg)$/);
}
